import { TableSortLabel as MuiTableSortLabel, TableSortLabelProps as MuiTableSortLabelProps } from '@material-ui/core';
import { KeyboardArrowDownOutlined, UnfoldMoreOutlined } from '@material-ui/icons';
import styled from 'styled-components';

// Make the icon visible always.

export const StyledSortLabel = styled(MuiTableSortLabel)`
  .NreTableSortLabelIcon {
    opacity: 1;
  }
`;

export type TableSortLabelProps = MuiTableSortLabelProps;

export function TableSortLabel(props: TableSortLabelProps) {
  // Use different icons depending on whether we're active.

  return (
    <StyledSortLabel
      classes={{ icon: 'NreTableSortLabelIcon' }}
      IconComponent={props.active ? KeyboardArrowDownOutlined : UnfoldMoreOutlined}
      {...props}
    />
  );
}

export default TableSortLabel;
